import createAPI from '../axios'

// 日志管理管理相关API
const logManagementSkillsTraining = {
    teachingLog: {
        queryList: config => createAPI('/logManagementSkillsTraining/teachingLog/queryList', 'post', config),
        queryJxrzList: config => createAPI('/logManagementSkillsTraining/teachingLog/queryJxrzList', 'post', config),
        saveRec: config => createAPI('/logManagementSkillsTraining/teachingLog/saveRec', 'post', config),
        queryRscList: config => createAPI('/logManagementSkillsTraining/teachingLog/queryRscList', 'post', config),
        deletefile: config => createAPI('/logManagementSkillsTraining/teachingLog/deletefile', 'post', config),
        save: config => createAPI('/logManagementSkillsTraining/teachingLog/save', 'post', config),
        del: config => createAPI('/logManagementSkillsTraining/teachingLog/del', 'post', config),
        getLoginUser: config => createAPI('/logManagementSkillsTraining/teachingLog/getLoginUser', 'post', config),

    },
    headteacherLog: {
        queryList: config => createAPI('/logManagementSkillsTraining/headteacherLog/queryList', 'post', config),
        queryBzrrzList: config => createAPI('/logManagementSkillsTraining/headteacherLog/queryBzrrzList', 'post', config),
        save: config => createAPI('/logManagementSkillsTraining/headteacherLog/save', 'post', config),
        del: config => createAPI('/logManagementSkillsTraining/headteacherLog/del', 'post', config),
    },
};

export default logManagementSkillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/logManagementSkillsTraining.js